module.exports = __webpack_public_path__ + "img/ADG.2c7b9789.svg";